import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';

export class FormsUtils {
  static markAllControlsAsTouchedAndDirty(
    abstractControls: AbstractControl[],
  ): void {
    FormsUtils.markAllControlsAsDirty(abstractControls);
    FormsUtils.markAllControlsAsTouched(abstractControls);
  }

  static markAllControlsAsDirty(abstractControls: AbstractControl[]): void {
    abstractControls.forEach((abstractControl) => {
      if (abstractControl instanceof FormControl) {
        (abstractControl as FormControl).markAsDirty({ onlySelf: true });
      } else if (abstractControl instanceof FormGroup) {
        abstractControl.markAsDirty({ onlySelf: true });
        this.markAllControlsAsDirty(
          Object.values((abstractControl as FormGroup).controls),
        );
      } else if (abstractControl instanceof FormArray) {
        abstractControl.markAsDirty({ onlySelf: true });
        this.markAllControlsAsDirty((abstractControl as FormArray).controls);
      }
    });
  }

  static markAllControlsAsTouched(abstractControls: AbstractControl[]): void {
    abstractControls.forEach((abstractControl) => {
      if (abstractControl instanceof FormControl) {
        (abstractControl as FormControl).markAsTouched({ onlySelf: true });
      } else if (abstractControl instanceof FormGroup) {
        abstractControl.markAsTouched({ onlySelf: true });
        this.markAllControlsAsTouched(
          Object.values((abstractControl as FormGroup).controls),
        );
      } else if (abstractControl instanceof FormArray) {
        abstractControl.markAsTouched({ onlySelf: true });
        this.markAllControlsAsTouched((abstractControl as FormArray).controls);
      }
    });
  }

  static isReadyForSave(fg: FormGroup): boolean {
    this.processBeforeSave(fg);
    return fg.valid;
  }

  static processBeforeSave(fg: FormGroup): void {
    FormsUtils.markAllControlsAsTouchedAndDirty(Object.values(fg.controls));

    if (!fg.valid) {
      setTimeout(() => {
        this.scrollToFirstInvalid();
      });
    }
  }

  private static scrollToFirstInvalid(
    invalidClassName: string = '.ng-invalid',
  ): void {
    const element = document.querySelector(
      invalidClassName,
    ) as HTMLElement | null;

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      element.focus();
    }
  }
}
